export default {
  permissions: [],
  permissionsObj: {},
  permissionsPage: {
    sms_campaign: false,
    app_push_campaign: false,
    whatsapp_campaign: false,
    channels: false,
    whatsapp_campaign_phoneId: "",
  },
};
